/**
 * "Knowledge & docs" — Dashboard section (ADR-0074).
 * Reconciled from apps/web docs-connectors + doc-inspector features.
 */
import type { DocPageContent } from '../types';

export const DASHBOARD_KNOWLEDGE_PAGE: DocPageContent = {
  slug: 'dashboard/knowledge',
  titleKey: 'docs.dashboard.knowledge.title',
  descriptionKey: 'docs.dashboard.knowledge.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.dashboard.knowledge.lead' },

    {
      kind: 'heading',
      level: 2,
      id: 'sources',
      textKey: 'docs.dashboard.knowledge.sources.heading',
    },
    { kind: 'paragraph', textKey: 'docs.dashboard.knowledge.sources.body' },

    {
      kind: 'heading',
      level: 2,
      id: 'walkthrough',
      textKey: 'docs.dashboard.knowledge.walkthrough.heading',
    },
    { kind: 'paragraph', textKey: 'docs.dashboard.knowledge.walkthrough.body' },
    {
      kind: 'steps',
      steps: [
        {
          titleKey: 'docs.dashboard.knowledge.walkthrough.step.add.title',
          textKey: 'docs.dashboard.knowledge.walkthrough.step.add.text',
        },
        {
          titleKey: 'docs.dashboard.knowledge.walkthrough.step.connect.title',
          textKey: 'docs.dashboard.knowledge.walkthrough.step.connect.text',
        },
        {
          titleKey: 'docs.dashboard.knowledge.walkthrough.step.sync.title',
          textKey: 'docs.dashboard.knowledge.walkthrough.step.sync.text',
        },
        {
          titleKey: 'docs.dashboard.knowledge.walkthrough.step.tune.title',
          textKey: 'docs.dashboard.knowledge.walkthrough.step.tune.text',
        },
      ],
    },

    { kind: 'heading', level: 2, id: 'sync', textKey: 'docs.dashboard.knowledge.sync.heading' },
    { kind: 'paragraph', textKey: 'docs.dashboard.knowledge.sync.body' },

    {
      kind: 'heading',
      level: 2,
      id: 'inspect',
      textKey: 'docs.dashboard.knowledge.inspect.heading',
    },
    { kind: 'paragraph', textKey: 'docs.dashboard.knowledge.inspect.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.dashboard.knowledge.override.exclude',
        'docs.dashboard.knowledge.override.pin',
        'docs.dashboard.knowledge.override.relabel',
        'docs.dashboard.knowledge.override.edit',
      ],
    },
    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.dashboard.knowledge.cite.title',
      textKey: 'docs.dashboard.knowledge.cite.body',
      links: {
        memory: { target: { docSlug: 'memory' }, labelKey: 'docs.dashboard.knowledge.cite.link' },
      },
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.dashboard.knowledge.next.prompts.title',
          textKey: 'docs.dashboard.knowledge.next.prompts.text',
          to: { docSlug: 'dashboard/prompts' },
        },
        {
          titleKey: 'docs.dashboard.knowledge.next.memory.title',
          textKey: 'docs.dashboard.knowledge.next.memory.text',
          to: { docSlug: 'memory' },
        },
      ],
    },
  ],
};
